import { render, staticRenderFns } from "./OrderSalesPage.vue?vue&type=template&id=0860cfc2&scoped=true&"
import script from "./OrderSalesPage.vue?vue&type=script&lang=js&"
export * from "./OrderSalesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0860cfc2",
  null
  
)

export default component.exports